import NZ_Ochardised_One from "../../../assets/images/NZ_OrchardisedTuatara_NEW.jpg";
import NZ_Ochardised_Two from "../../../assets/images/NZ_Ochardised_Two.png";
import NZ_Ochardised_Three from "../../../assets/images/NZ_OrchardisedTuatara2.jpg";
import NZ_Ochardised_Four from "../../../assets/images/NZ_Ochardised_Four.png";
import NZ_Ochardisedback from "../../../assets/images/NZ_Orchardisedback.jpg";
import NZ_Ochardised_Five from "../../../assets/images/OrchardisedLH.jpg";
import NZ_Ochardised_Six from "../../../assets/images/NZ_OrchardiseTuatarainKiwifruitfarm.jpg";
import NZ_Ochardised_Seven from "../../../assets/images/NZ_OrchardiseTuatara4.jpg";
import PETROLSIDE from "../../../assets/images/Orchardised_Tuatara.jpg";
import Orchardised_front from "../../../assets/images/OrchardisedFront3.jpg";
import Orchardised_front1 from "../../../assets/images/OrchardisedTuatara1.jpg";
import React, { useState } from "react";
const images = [
  NZ_Ochardised_One,
  // NZ_Ochardised_Two,
  NZ_Ochardisedback,
  // NZ_Ochardised_Three,
  // PETROLSIDE,
  Orchardised_front1,
  // NZ_Ochardised_Four,
  Orchardised_front,
  NZ_Ochardised_Five,
  NZ_Ochardised_Six,
  // NZ_Ochardised_Seven,
];
const NzOrchardisedModels = () => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  // Tooltip states
  const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });
  const [showTooltip, setShowTooltip] = useState(false);

  const openGallery = (i) => {
    setIndex(i);
    setOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeGallery = () => {
    setOpen(false);
    document.body.style.overflow = "auto";
  };

  const prevImg = () => setIndex((i) => (i === 0 ? images.length - 1 : i - 1));

  const nextImg = () => setIndex((i) => (i === images.length - 1 ? 0 : i + 1));

  return (
    <>
      <div className="bg-white">
        <div className="custom-container px-[20px] sm:px-[30px] text-start mx-auto">
          <div className="max-w-[1200px] mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5 justify-items-center">
              {/* 1 */}
              <div
                onClick={() => openGallery(0)}
                onMouseMove={(e) => {
                  setTooltipPos({ x: e.clientX, y: e.clientY });
                  setShowTooltip(true);
                }}
                onMouseLeave={() => setShowTooltip(false)}
                className="border border-black w-full aspect-[1.2] flex items-center justify-center overflow-hidden cursor-pointer"
              >
                <img
                  src={NZ_Ochardised_One}
                  className="w-full h-full object-cover"
                  style={{ objectPosition: "70%" }}
                />
              </div>

              {/* 2 */}
              <div
                onClick={() => openGallery(1)}
                onMouseMove={(e) => {
                  setTooltipPos({ x: e.clientX, y: e.clientY });
                  setShowTooltip(true);
                }}
                onMouseLeave={() => setShowTooltip(false)}
                className="border border-black w-full aspect-[1.2] flex items-center justify-center overflow-hidden cursor-pointer"
              >
                <img
                  src={NZ_Ochardisedback}
                  className="w-full h-full object-cover object-[0px_72%]"
                />
              </div>

              {/* 3 */}
              <div
                onClick={() => openGallery(2)}
                onMouseMove={(e) => {
                  setTooltipPos({ x: e.clientX, y: e.clientY });
                  setShowTooltip(true);
                }}
                onMouseLeave={() => setShowTooltip(false)}
                className="border border-black w-full aspect-[1.2] flex items-center justify-center overflow-hidden cursor-pointer"
              >
                <img
                  src={Orchardised_front1}
                  className="w-full h-full object-cover object-[70%]"
                />
              </div>

              {/* 4 */}
              <div
                onClick={() => openGallery(3)}
                onMouseMove={(e) => {
                  setTooltipPos({ x: e.clientX, y: e.clientY });
                  setShowTooltip(true);
                }}
                onMouseLeave={() => setShowTooltip(false)}
                className="border border-black w-full aspect-[1.2] flex items-center justify-center overflow-hidden cursor-pointer"
              >
                <img
                  src={Orchardised_front}
                  className="w-full h-full object-cover object-[0px_85%]"
                />
              </div>

              {/* 5 */}
              <div
                onClick={() => openGallery(4)}
                onMouseMove={(e) => {
                  setTooltipPos({ x: e.clientX, y: e.clientY });
                  setShowTooltip(true);
                }}
                onMouseLeave={() => setShowTooltip(false)}
                className="border border-black w-full aspect-[1.2] flex items-center justify-center overflow-hidden cursor-pointer"
              >
                <img
                  src={NZ_Ochardised_Five}
                  className="w-full h-full object-cover object-[92%]"
                />
              </div>

              {/* 6 */}
              <div
                onClick={() => openGallery(5)}
                onMouseMove={(e) => {
                  setTooltipPos({ x: e.clientX, y: e.clientY });
                  setShowTooltip(true);
                }}
                onMouseLeave={() => setShowTooltip(false)}
                className="border border-black w-full aspect-[1.2] flex items-center justify-center overflow-hidden cursor-pointer"
              >
                <img
                  src={NZ_Ochardised_Six}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {open && (
        <div
          className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-[99999]"
          onClick={closeGallery}
        >
          <div className="relative" onClick={(e) => e.stopPropagation()}>
            <button
              onClick={closeGallery}
              className="absolute top-[-50px] right-0 text-white text-4xl md:text-5xl lg:text-6xl"
            >
              ×
            </button>

            <button
              onClick={prevImg}
              className="absolute left-[-60px] top-1/2 -translate-y-1/2 text-white text-6xl cursor-pointer"
            >
              ‹
            </button>
            <img
              src={images[index]}
              className="max-h-[80vh] max-w-[90vw] object-contain bg-white rounded-lg shadow-xl"
            />

            <button
              onClick={nextImg}
              className="absolute right-[-60px] top-1/2 -translate-y-1/2 text-white text-6xl cursor-pointer"
            >
              ›
            </button>
          </div>
        </div>
      )}

      {/* Tooltip */}
      {showTooltip && (
        <div
          className="fixed z-[99999] bg-black text-white text-[13px] px-3 py-1 rounded-md shadow-lg pointer-events-none"
          style={{ top: tooltipPos.y + 15, left: tooltipPos.x + 15 }}
        >
          Click here to expand
        </div>
      )}
    </>
  );
};
export default NzOrchardisedModels;
